import { render, staticRenderFns } from "./ProjectListPage.vue?vue&type=template&id=2edbebb4&scoped=true&"
import script from "./ProjectListPage.vue?vue&type=script&lang=js&"
export * from "./ProjectListPage.vue?vue&type=script&lang=js&"
import style0 from "./ProjectListPage.vue?vue&type=style&index=0&id=2edbebb4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2edbebb4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VRow})
